import { trackingService } from '../services/trackingService';
import { getUser } from './user';

// Función para configurar interceptores de tracking en instancias de axios
export const setupTrackingInterceptors = (axiosInstance: any) => {
  // Interceptor de request para trackear llamadas API
  axiosInstance.interceptors.request.use(
    (config: any) => {
      const user = getUser();
      if (user?.id) {
        // Trackear inicio de llamada API
        trackingService.trackUserBehavior({
          action: 'api_request_start',
          metadata: {
            url: config.url,
            method: config.method?.toUpperCase(),
            baseURL: config.baseURL,
            timeout: config.timeout,
          },
        });
      }
      return config;
    },
    (error: any) => {
      return Promise.reject(error);
    }
  );

  // Interceptor de response para trackear respuestas API
  axiosInstance.interceptors.response.use(
    (response: any) => {
      const user = getUser();
      if (user?.id) {
        // Trackear respuesta exitosa
        trackingService.trackUserBehavior({
          action: 'api_response_success',
          metadata: {
            url: response.config.url,
            method: response.config.method?.toUpperCase(),
            status: response.status,
            responseTime: response.config.metadata?.endTime - response.config.metadata?.startTime,
          },
        });
      }
      return response;
    },
    (error: any) => {
      const user = getUser();
      if (user?.id) {
        // Trackear error de API
        trackingService.trackUserBehavior({
          action: 'api_response_error',
          metadata: {
            url: error.config?.url,
            method: error.config?.method?.toUpperCase(),
            status: error.response?.status,
            errorMessage: error.message,
            errorCode: error.code,
          },
        });
      }
      return Promise.reject(error);
    }
  );

  // Interceptor para medir tiempo de respuesta
  axiosInstance.interceptors.request.use(
    (config: any) => {
      config.metadata = { startTime: Date.now() };
      return config;
    }
  );

  axiosInstance.interceptors.response.use(
    (response: any) => {
      response.config.metadata = { 
        ...response.config.metadata,
        endTime: Date.now() 
      };
      return response;
    }
  );
};

// Función para trackear descargas específicas
export const trackDownloadFromResponse = (
  response: any,
  studentId: string,
  reportType: string,
  fileName?: string
) => {
  const user = getUser();
  if (user?.id) {
    // Obtener información del archivo de la respuesta
    const contentLength = response.headers['content-length'];
    
    trackingService.trackDownload({
      student_id: studentId,
      report_type: reportType,
      file_name: fileName,
      file_size: contentLength ? parseInt(contentLength) : undefined,
      download_url: response.config.url,
    });
  }
};

// Función para trackear errores de descarga
export const trackDownloadError = (
  error: any,
  studentId: string,
  reportType: string
) => {
  const user = getUser();
  if (user?.id) {
    trackingService.trackUserBehavior({
      action: 'download_error',
      metadata: {
        student_id: studentId,
        report_type: reportType,
        error_message: error.message,
        error_status: error.response?.status,
      },
    });
  }
};

export default setupTrackingInterceptors;
